import React from "react";
import { Button } from "@material-ui/core";
import { Close, ArrowBack } from "@material-ui/icons";
import "./styles.css";

const NavigationTextButton = ({
  navigationType = "back",
  buttonText = "",
  onClick = () => { }
}) => {
  const Icon = () => (
    <>
      {
        navigationType === "back" ?
          <ArrowBack className="nav-text-button-icon" /> :
          <Close className="nav-text-button-icon" />
      }
    </>
  );

  return (
    <Button onClick={onClick} className="nav-text-button-wrapper">
      <Icon />
      <div className="nav-text-button-text">{buttonText}</div>
    </Button>
  );
};

export default NavigationTextButton;
